/**
 * A disabled lab account blocks its own users (MIL-419): a regular lab user whose lab is not
 * active is signed out, with the same message as a disabled user.
 *
 * Milva staff are never blocked by this. A staff member's `currentUser` is built from their Lab
 * Admin user document and they can open any lab, so they must still be able to open a disabled
 * one — to support it, or to reactivate it. They are still subject to their own user's state,
 * which the router's auth guard checks separately.
 *
 * A lab account that has not loaded is not treated as disabled: the guard only signs someone
 * out on a state it has actually read. Kept as a pure function so the decision is testable
 * without a router.
 */
export function isLabAccountBlockingUser({
  isLabAdminUser,
  labAccount,
}: {
  isLabAdminUser: boolean
  labAccount: { activeState?: string } | null | undefined
}): boolean {
  if (isLabAdminUser) return false
  if (!labAccount) return false

  return labAccount.activeState !== 'active'
}
